//convert date 2024-02-26 00:00:00  into 26-02-2024
const convertDateForDisplay = (date) => {
  const inputDate = new Date(date);
  // const formattedDate = inputDate.toISOString().split('T')[0];
  const formattedDate = inputDate
    .toLocaleDateString("en-GB")
    .split("/")
    .join("-");
  return formattedDate;
};

//convert date into yyyy-mm-dd
const convertDateForApi = (date) => {
    const inputDate = new Date(date);
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, '0'); // Adding leading zero if needed
    const day = inputDate.getDate().toString().padStart(2, '0'); // Adding leading zero if needed
    return `${year}-${month}-${day}`;
};

const dateFormat = ()=>{
  return 'dd-MM-yyyy';
}

export  { convertDateForApi, convertDateForDisplay,dateFormat };
